import React from 'react';
import PropTypes from 'prop-types';
import 'intersection-observer';
import Observer from '@researchgate/react-intersection-observer';

import ImageCarouselItemPreview from './ImageCarouselItemPreview';

class ImageCarousel extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      mainImage: props.images && props.images[0] ? props.images[0] : null
    };

    this.previewsElement = React.createRef();

    this.switchMainImage = this.switchMainImage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.scrollLeft = this.scrollLeft.bind(this);
    this.scrollRight = this.scrollRight.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  switchMainImage(image) {
    this.setState({
      mainImage: image
    });
  }

  handleChange({ isIntersecting, target }) {
    if (target.classList.contains('first')) {
      this.setState((state) => ({
        ...state,
        isLeftArrowActive: !isIntersecting
      }));
    }
    
    if (target.classList.contains('last')) {
      this.setState((state) => ({
        ...state,
        isRightArrowActive: !isIntersecting
      }));
    }
  }

  scrollLeft() {
    this.previewsElement.current.scrollBy(-100, 0);
  }

  scrollRight() {
    this.previewsElement.current.scrollBy(100, 0);
  }

  renderEmpty() {
    return (
      <div className={'sm-image-carousel'}>
        <div className={'sm-product-image empty'}>
          <span role={'img'} aria-label={'no product image'}>🌈</span>
        </div>
      </div>
    );
  }

  render() {
    const { props: { images }, state } = this;
    if (!state.mainImage || !state.mainImage.url) {
      return this.renderEmpty();
    }
    const mainImageClassnames = ['sm-product-image'];

    return (
      <div className={'sm-image-carousel'}>
        <div className={mainImageClassnames.join(' ')}>
          <a>
            <img src={state.mainImage.url} alt={'Product'} />
          </a>
        </div>
        <div className={'sm-images-wrapper'}>
          <a
            onClick={this.scrollLeft}
            href={'#'}
            className={`arrow left ${this.state.isLeftArrowActive ? 'active' : ''}`}
          >
            &lt;
          </a>
          <ul className={'sm-product-images'} ref={this.previewsElement}>
            {images && images.map((image, index, array) => {
              const classNames = { 0: 'first', [array.length - 1]: 'last' };
              const className = classNames[index];
              return (
                <Observer
                  threshold={[1]}
                  disabled={!className}
                  root={'.sm-product-images'}
                  onChange={this.handleChange}
                >
                  <ImageCarouselItemPreview
                    key={image.url}
                    image={image}
                    onItemClick={this.switchMainImage}
                    isActive={image.url === this.state.mainImage.url}
                    className={className}
                  />
                </Observer>
              );
            })}
          </ul>
          <a
            onClick={this.scrollRight}
            href={'#'}
            className={`arrow right ${this.state.isRightArrowActive ? 'active' : ''}`}
          >
            &gt;
          </a>
        </div>
      </div>
    );
  }
}

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ImageCarousel;
